import AWS from 'aws-sdk/global'
import CognitoIdentityServiceProvider from 'aws-sdk/clients/cognitoidentityserviceprovider'
import { AWS_REGION, COGNITO_PUBLIC_CLIENT_ID } from '../env'

AWS.config.update({ region: AWS_REGION })
const Cognito = new CognitoIdentityServiceProvider()

const signUp = async ({ email, password, firstName, lastName, birthdate }) => {
  const params = {
    ClientId: COGNITO_PUBLIC_CLIENT_ID,
    Username: email,
    Password: password,
    UserAttributes: [
      {
        Name: 'given_name',
        Value: firstName,
      },
      {
        Name: 'family_name',
        Value: lastName,
      },
      {
        Name: 'birthdate',
        Value: birthdate,
      },
    ],
  }
  return await Cognito.signUp(params).promise()
}

const confirmSignUp = async ({ username, confirmationCode }) => {
  const params = {
    ClientId: COGNITO_PUBLIC_CLIENT_ID,
    Username: username,
    ConfirmationCode: confirmationCode,
  }
  return await Cognito.confirmSignUp(params).promise()
}

const resendConfirmationCode = async ({ username }) => {
  const params = {
    ClientId: COGNITO_PUBLIC_CLIENT_ID,
    Username: username,
  }
  return await Cognito.resendConfirmationCode(params).promise()
}

export { signUp, confirmSignUp, resendConfirmationCode }
